import { createContext, Dispatch } from "react";
import { Datasheet } from "@/api/datasheets";
import { InspectorRow, InspectorWeld } from "@/api/hitachi/rbi";
import { InspectorState, StateType, WeldListFilters } from "./types";
import { Project } from "@/api/project";
import { SubProject } from "@/api/subProject";

export interface IInspectorContext {
  state: InspectorState;
  updateState: Dispatch<RbiAction>;
}

export const InspectorContext = createContext<IInspectorContext>({} as IInspectorContext);

export type RbiAction = {
  type: StateType;
  payload?: Project | SubProject | Datasheet | InspectorWeld[] | InspectorRow[] | WeldListFilters | string;
};

export const reducer = (state: InspectorState, action: RbiAction): InspectorState => {
  switch (action.type) {
    case "Project": {
      const project = action.payload as Project;
      return { ...state, project, subProject: undefined, datasheet: undefined, operation: undefined };
    }
    case "SubProject":
      return { ...state, subProject: action.payload as SubProject, datasheet: undefined, operation: undefined };
    case "Datasheet":
      return { ...state, datasheet: action.payload as Datasheet, welds: [], operation: undefined };
    case "Discipline":
      return { ...state, discipline: action.payload as string, welds: [], inspections: [] };
    case "Operation":
      return { ...state, operation: action.payload as string, welds: [], inspections: [] };
    case "Welds":
      return { ...state, welds: action.payload as InspectorWeld[], inspections: [] };
    case "Inspections":
      return { ...state, inspections: action.payload as InspectorRow[] };
    case "Filters":
      return { ...state, filters: action.payload as WeldListFilters, welds: [], inspections: [] };
    default:
      return state;
  }
};
